export default __webpack_public_path__ + "static/media/pyay_1(13.3.2021).37bdffd2.png";